<div class="modal-container" (click)="closeAllDropdowns()" *transloco="let t; prefix: 'workOrder'">
  <div class="modal-container__header">
    <h3 class="modal-container__header-title">{{ t('modals.viewDetails.title') }}</h3>
    <button class="modal-container__header-btn" (click)="closeModal()" [title]="'common.close' | transloco">
      <svg class="modal-container__header-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1959 6.34399L11.9529 10.586L7.71087 6.34399L6.29688 7.75799L10.5389 12L6.29688 16.242L7.71087 17.656L11.9529 13.414L16.1959 17.656L17.6099 16.242L13.3679 12L17.6099 7.75799L16.1959 6.34399Z" fill="#9FA1A4"/>
      </svg>
    </button>
  </div>

  <div class="modal-container__body">
    <!-- Left Column - Work Order Details -->
    <div class="modal-column modal-column--left">
      <span class="section-title">{{ t('modals.viewDetails.workOrderDetails') }}</span>

      <!-- Work Order ID and Asset Row -->
      <div class="modal-form__row">
        <!-- Work Order ID (Read-only) -->
        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.workOrderId') }} <span class="required">*</span></label>
          <div class="readonly-input-wrapper">
            <input class="modal-input readonly" type="text" [value]="workOrderIdDisplayText" readonly />
          </div>
        </div>

        <!-- Asset (Read-only) -->
        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.asset') }} <span class="required">*</span></label>
          <div class="readonly-input-wrapper">
            <input class="modal-input readonly" type="text" [value]="assetDisplayText" readonly />
          </div>
        </div>
      </div>

      <!-- Source (Read-only) -->
      <div class="modal-form__field">
        <label class="modal-label">{{ t('modals.shared.source') }}<span class="required">*</span></label>
        <div class="readonly-input-wrapper">
          <input class="modal-input readonly" type="text" [value]="sourceDisplayText" readonly />
        </div>
      </div>

      <!-- Service Type Dropdown -->
      <div class="modal-form__field" (click)="$event.stopPropagation()">
        <label class="modal-label">{{ t('modals.shared.serviceType') }} <span class="required">*</span></label>
        @if (isFieldsDisabled) {
          <div class="readonly-input-wrapper">
            <input class="modal-input readonly" type="text" [value]="serviceTypeDisplayText" readonly />
          </div>
        } @else {
          <div class="dropdown-input-wrapper" (click)="toggleServiceTypeDropdown()">
            <input class="modal-input" type="text" [value]="serviceTypeDisplayText" readonly />
            <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.862 6.19534L7.99998 9.05734L5.13798 6.19534L4.19531 7.13801L7.99998 10.9427L11.8046 7.13801L10.862 6.19534Z" fill="#9FA1A4"/>
            </svg>
          </div>
          @if (serviceTypeDropdownOpen) {
            <ul class="modal-dropdown-menu">
              @for (type of serviceTypes; track type.id) {
                <li (click)="selectServiceType(type)">{{ type.name | transloco }}</li>
              }
            </ul>
          }
        }
      </div>

      <!-- Schedule Date and Workshop Row -->
      <div class="modal-form__row">
        <!-- Schedule Date -->
        <div class="modal-form__field modal-form__field--half" (click)="$event.stopPropagation()">
          @if (isFieldsDisabled || isWorkOrderLoading) {
            <label class="modal-label">{{ t('modals.shared.scheduleDate') }} <span class="required">*</span></label>
            <div class="readonly-input-wrapper">
              <input class="modal-input readonly" type="text" [value]="isWorkOrderLoading ? t('modals.viewDetails.loadingScheduleDate') : scheduledDateString" readonly />
            </div>
          } @else {
            <app-flatpickr-date-picker
              [label]="t('modals.shared.scheduleDate')"
              [(value)]="scheduledDateString"
              (valueChange)="onScheduledDateChange($event)"
              [minDate]="'today'"
              [altFormat]="'d/m/Y'"
              [placeholder]="t('modals.shared.datePlaceholder')"
              [required]="true">
            </app-flatpickr-date-picker>
          }
        </div>

        <!-- Assign Workshop -->
        <div class="modal-form__field modal-form__field--half" (click)="$event.stopPropagation()">
          <label class="modal-label">{{ t('modals.shared.assignWorkshop') }} <span class="required">*</span></label>
          @if (isFieldsDisabled) {
            <div class="readonly-input-wrapper">
              <input class="modal-input readonly" type="text" [value]="workshopDisplayText" readonly />
            </div>
          } @else {
            <div class="dropdown-input-wrapper" (click)="toggleWorkshopDropdown()">
              <input class="modal-input" type="text" [value]="workshopDisplayText" readonly />
              <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.862 6.19534L7.99998 9.05734L5.13798 6.19534L4.19531 7.13801L7.99998 10.9427L11.8046 7.13801L10.862 6.19534Z" fill="#9FA1A4"/>
              </svg>
            </div>
            @if (workshopDropdownOpen) {
              <ul class="modal-dropdown-menu">
                @for (workshop of workshops; track workshop.id) {
                  <li (click)="selectWorkshop(workshop)">{{ workshop.name }}</li>
                }
              </ul>
            }
          }
        </div>
      </div>

      <!-- Maintenance Reason (Read-only) -->
      <div class="modal-form__field">
        <label class="modal-label">{{ t('modals.shared.maintenanceReason') }}</label>
        <div class="readonly-input-wrapper">
          <input class="modal-input readonly" type="text" [value]="maintenanceReasonDisplayText" [placeholder]="t('modals.shared.maintenanceReasonPlaceholder')" readonly />
        </div>
      </div>

      <!-- Estimated Cost and Time Row -->
      <div class="modal-form__row">
        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.estimatedCost') }}</label>
          <div class="input-with-prefix readonly-input-wrapper">
            <span class="input-prefix">{{ currencySymbol }}</span>
            <input class="modal-input readonly" type="number" [value]="formData.estimatedCost" placeholder="0" readonly />
          </div>
        </div>

        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.estimatedTime') }}</label>
          <div class="input-with-suffix readonly-input-wrapper">
            <input class="modal-input readonly" type="number" [value]="formData.estimatedTime" placeholder="0" readonly />
            <span class="input-suffix" [style.left.px]="timeSuffixLeft">{{ t('modals.shared.hours') }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column - Assignment & Status -->
    <div class="modal-column modal-column--right">
      <!-- Assigned To Section -->
      <span class="section-title">{{ t('modals.shared.assignedTo') }}</span>
      <div class="technician-info">
        <div class="technician-avatar">
          <img src="assets/images/default-avatar.png" [attr.alt]="'assetOverview.timeline.technician' | transloco" onerror="this.style.display='none'" />
          <span class="avatar-fallback">{{ formData.technicianName.charAt(0) }}</span>
        </div>
        <div class="technician-details">
          <span class="technician-name">{{ technicianDisplayText }}</span>
          <span class="technician-role">{{ formData.technicianSpecialization }}</span>
        </div>
      </div>

      <!-- Parts Required Section -->
      <div class="parts-section" (click)="$event.stopPropagation()">
        <span class="section-title">{{ t('modals.viewDetails.partsRequired') }}</span>
        <div class="parts-chips">
          @if (isPartsLoading) {
            <span class="parts-chips-status">
              <span class="spinner-border spinner-border-sm"></span>
              {{ t('modals.viewDetails.loadingParts') }}
            </span>
          }

          @for (part of formData.partsRequired; track $index) {
            <div class="part-chip">
              <span>{{ part }}</span>
              <button class="remove-part-btn" (click)="removePart($index)">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 3L3 9" stroke="#4D4749" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3 3L9 9" stroke="#4D4749" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          }
        </div>
      </div>

      <!-- Downtime -->
      <div class="modal-form__field">
        <label class="modal-label">{{ t('modals.viewDetails.downtime') }}</label>
        <span class="downtime-value">{{ downtimeDisplayText }}</span>
      </div>

      <!-- Status -->
      <div class="modal-form__field">
        <label class="modal-label">{{ t('modals.viewDetails.status') }}</label>
        <span class="status-badge" [ngClass]="statusClass">
          <span class="status-indicator">
            @if (displayStatus === WorkOrderStatus.Open || displayStatus === WorkOrderStatus.InProgress) {
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM8.862 9.80467L6 6.94267V2.66667H7.33333V6.39067L9.80467 8.862L8.862 9.80467Z" />
              </svg>
            }
            @if (displayStatus === WorkOrderStatus.Completed) {
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM5.334 9.60867L2.85867 7.13867L3.8 6.19467L5.33267 7.72467L8.862 4.19533L9.80467 5.138L5.334 9.60867Z" />
              </svg>
            }
            @if (
              displayStatus === WorkOrderStatus.Pending ||
              displayStatus === WorkOrderStatus.Rejected ||
              displayStatus === OVERDUE_STATUS
            ) {
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.63533 0C2.97667 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3287 0 6.63533 0ZM7.33333 10H6V8.66667H7.33333V10ZM7.33333 7.33333H6V3.33333H7.33333V7.33333Z" />
              </svg>
            }
          </span>
          {{ statusLabel }}
        </span>
      </div>

      <!-- Priority Dropdown -->
      <div class="modal-form__field" (click)="$event.stopPropagation()">
        <label class="modal-label">{{ t('modals.viewDetails.priority') }}</label>
        @if (isFieldsDisabled) {
          <div class="readonly-input-wrapper">
            <input class="modal-input readonly" type="text" [value]="selectedPriorityName" readonly />
          </div>
        } @else {
          <div class="dropdown-input-wrapper priority-dropdown" (click)="togglePriorityDropdown()">
            <input class="modal-input" type="text" [value]="selectedPriorityName" readonly />
            <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.862 6.19534L7.99998 9.05734L5.13798 6.19534L4.19531 7.13801L7.99998 10.9427L11.8046 7.13801L10.862 6.19534Z" fill="#9FA1A4"/>
            </svg>
          </div>
          @if (priorityDropdownOpen) {
            <ul class="modal-dropdown-menu">
              @for (priority of priorities; track priority.id) {
                <li (click)="selectPriority(priority)">{{ priority.name | transloco }}</li>
              }
            </ul>
          }
        }
      </div>

      <!-- Comment -->
      <div class="modal-form__field">
        <label class="modal-label">{{ t('modals.viewDetails.comment') }}</label>
        <textarea class="modal-textarea" [(ngModel)]="formData.comment" [placeholder]="t('modals.viewDetails.commentPlaceholder')"></textarea>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="modal-actions">
    <button class="modal-btn cancel" (click)="closeModal()">{{ 'common.cancel' | transloco }}</button>
    <button class="modal-btn save" [disabled]="!isFormValid || isLoading" (click)="saveChanges()">
      @if (isLoading) {
        <span class="spinner-border"></span>
      } @else {
        <span>{{ t('modals.shared.saveChanges') }}</span>
      }
    </button>
  </div>
</div>